<template>
  <div>
    <div>
      <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
      ></loading>
    </div>
    <b-row v-if="editarDatosEnvio">
      <p>Edicion de datos de paquetería</p>
    </b-row>
    <b-row class="text-left m-2" v-if="paqueterias !== null && datosOdt.paqueteria">
      <b-col :cols="!modalEnvio ? 3 : 6 ">
        <span>Paquetería</span>
        <v-select
            v-model="objGuardar.idPaqueteria"
            placeholder="Selecciona una paqueteria"
            id="idPaqueteria"
            label="descripcion"
            required
            :options="paqueterias"
            :reduce="(variable) => variable.idPaqueteria"
        />
      </b-col>
      <b-col :cols="!modalEnvio ? 3 : 6 ">
        <span>No. de seguimiento</span>
        <b-form-input
            class="form-control form-control-sm"
            placeholder="Ingresa el numero de seguimiento"
            v-model="objGuardar.noSeguimiento"
            type="number"
            min="0"
        ></b-form-input>
      </b-col>
      <b-col :cols="!modalEnvio ? 3 : 6 " class="mt-4" align="center">
        <b-button variant="outline-info" pill style="background: #0155A7; color: aliceblue" size="sm" @click="guardarEnvio()" :disabled="validarCampos()">
          <span>Guardar</span>
        </b-button>
      </b-col>
      <b-col v-if="modalEnvio" :cols="!modalEnvio ? 3 : 6 " class="mt-4" align="center">
        <b-button style="background: white; color: #1B81AF" variant="primary" pill size="sm" @click="$emit('cerrarModal');">
          <span>Cancelar</span>
        </b-button>
      </b-col>
    </b-row>
    <div class="text-left m-2" v-else-if="datosOdt.recoleccion">
      <b-row class="mb-4">
        <b-col :cols="!modalEnvio ? 3 : 6 ">
          <p>Nombre del mensajero que recolecta</p>
          <b-form-input
              class="form-control form-control-sm"
              placeholder="Ingresa el nombre"
              v-model="objGuardar.mensajero"
              type="text"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col :cols="!modalEnvio ? 3 : 6 " class="mt-4" align="center">
          <b-button variant="outline-info" pill style="background: #0155A7; color: aliceblue" size="sm" @click="guardarEnvio()" :disabled="validarCampos()">
            <span>Guardar</span>
          </b-button>
        </b-col>
        <b-col v-if="modalEnvio" :cols="!modalEnvio ? 3 : 6 " class="mt-4" align="center">
          <b-button style="background: white; color: #1B81AF" variant="primary" pill size="sm" @click="$emit('cerrarModal');">
            <span>Cancelar</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "EnvioRecoleccion",
  props: {
    datosOdt: Object,
    paqueterias: Array,
    editarDatosEnvio: {
      type:Boolean,
      default: false,
    },
    modalEnvio: {
      type:Boolean,
      default: false,
    },
  },
  data: () => ({
    objGuardar: {
      idOdtLaboratorio: null,
      idSolicitudEtapa: null,
      idPaqueteria: null,
      noSeguimiento: null,
      mensajero: null,
    },
    loading: false,
  }),
  created() {
    this.objGuardar.idOdtLaboratorio = this.modalEnvio ? this.datosOdt.idOdt : this.$route.params.idOdt;
    this.objGuardar.idSolicitudEtapa = this.modalEnvio ? this.datosOdt.idSolicitudEtapa : this.$route.params.idSolicitudEtapa;
  },
  methods:{
    guardarEnvio(){
      this.loading = true;
      this.$http.post(this.$api + "labs/odt/guardarEnvioFisico", this.objGuardar).then(response => {
        if (response.status === 200) {
          this.loading = false;
          if(response.data.data !== 0){
            let mensaje = this.objGuardar.idPaqueteria != null ? 'paquetería' : 'mensajero';
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "Información de " + mensaje + " guardada exitosamente",
            });
            this.$emit('editarEnvio');
            this.$router.go(0);
          }else{
            this.$swal({
              icon: "error",
              title: "Error",
              text: "Hubo un problema al guardar los datos, intente de nuevo",
            });
          }
        }
      }).catch(error => {
        this.loading = false;
        console.log(error);
      })
    },

    validarCampos(){
      if(this.datosOdt.paqueteria && (this.objGuardar.idPaqueteria === null || this.objGuardar.noSeguimiento === null)){
        return true;
      } else if(this.datosOdt.recoleccion && this.objGuardar.mensajero === null){
        return true;
      } else {
        return false;
      }
    }
  },
}
</script>
<style scoped>
</style>